export default function DarkGreenPill(props: { children: string }) {
    return (
        <p className="catalog-pill bg-[#006059] text-white">{props.children}</p>
    );
}
